<nb-icon class="cursor-pointer" icon="image-outline" [nbPopover]="card" nbPopoverTrigger="hint"></nb-icon>


<ng-template #card>
  <nb-card class="popover-card">
    <nb-card-body>
      <img [src]="basePath + image">
    </nb-card-body>
  </nb-card>
</ng-template>